"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./BaseAdapter.cjs");class o extends r.BaseAdapter{initProvider(e){}recordError(e,d){}shutdown(){return Promise.resolve()}}exports.NoopAdapter=o;
//# sourceMappingURL=NoopAdapter.cjs.map
